module.exports = __webpack_public_path__ + "img/flight-booking-paper-pattern.ac1342ac.png";